<template>
<div>
  <v-sheet>
    <v-container>
      <h2>Edycja - {{roleEdit.name}}</h2>
      <v-layout row wrap>
        <v-flex xs3 v-for="(perm,index) in permisions" :key="perm.name+'_v_'+index">
          <v-checkbox
                      class="span-blcok"
                      :label="role.translatePermission(perm.name)"
                      v-model="model[perm.name]"
                      required>
          </v-checkbox>
        </v-flex>
      </v-layout>
      <v-btn color="green" @click="updateRole()"><v-icon>check</v-icon></v-btn>
    </v-container>
  </v-sheet>
</div>
</template>
<script>
import Role from '@/plugins/Role'
import UserRules from '@/mixins/UserRules'
import Messenger from "@/plugins/Messenger";
export default {
  mixins: [UserRules],
  props: ['permisions', 'roleEdit'],
  data() {
    return {
      pagination: {
        rowsPerPage: 25,
      },
      role: new Role(),
      dialog: false,
      permissions: [],
      model: {},
      roles: [],
      passwordRules: [v => (!!v || !this.changePass) || this.$t('user.create.error.empty-pass')],
    }
  },
  created() {
    this.roleEdit.permissions.forEach(perm => this.model[perm] = true)
  },
  methods: {
    updateRole() {
      let permisionsToUpdate = []
      for(let permision in this.model){
        if(this.model[permision]) {
          permisionsToUpdate.push(permision)
        }
      }

      this.$http.put('/rbac/roles/' + this.roleEdit.name,{'permisions' : permisionsToUpdate}).then(data =>{
        Messenger.emitSuccess("Zaktualizowano role " + this.roleEdit.name)
        this.$emit('updated', data.data)
      }).catch(()=> Messenger.emitError("Probelm z aktualizacją roli"))

    }
  },
}
</script>


<style>
.text-overflow {
  text-align: center;
  word-wrap: break-word;
  align: center;
  vertical-align: middle;

}

.center {
  margin: 0 auto;
}

.span-blcok {
  display: inline-block;
  height: 50px;
  white-space: normal;
}

.header {
  width: 200px !important;
}

.aqua-color {
  background-color: #e6faff;
}
</style>
